import { getContentTarget } from "./utils";

enum EDeviceClasses {
    "USING_KEYBOARD" = "using-keyboard",
    "USING_TAB" = "using-tab",
    "USING_MOUSE" = "using-mouse",
}

export const addDeviceInputListeners = () => {
    window.onload = () => {
        const target = getContentTarget();

        const onMouseDown = (e: MouseEvent) => {
            if (e instanceof MouseEvent) {
                target.classList.remove(EDeviceClasses.USING_KEYBOARD);
                target.classList.remove(EDeviceClasses.USING_TAB);
                target.classList.add(EDeviceClasses.USING_MOUSE);
            }
        };

        const onKeyDown = (e: KeyboardEvent) => {
            if (e instanceof KeyboardEvent) {
                target.classList.remove(EDeviceClasses.USING_MOUSE);
                target.classList.add(EDeviceClasses.USING_KEYBOARD);

                if (e.key === "Tab") {
                    target.classList.add(EDeviceClasses.USING_TAB);
                } else {
                    target.classList.remove(EDeviceClasses.USING_TAB);
                }
            }
        };

        target.addEventListener("mousedown", onMouseDown);
        target.addEventListener("keydown", onKeyDown);
    };
};
